const routes = [
  {
    path: 'support',
    component: () => import('@/views/support/Wrapper.vue'),
    children: [
      {
        path: 'menu',
        name: 'support',
        component: () => import('@/views/support/Menu.vue'),
      },
      {
        path: 'settings',
        name: 'settings',
        component: () => import('@/views/support/settings/Index.vue'),
      },
    ],
  },
];

export default routes;
